import React, { Suspense } from 'react';
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";
import { langResources } from './languageResources';

i18next.init({
    interpolation: { escapeValue: false },  // React already does escaping
    lng: 'en',                              // default language to use
    resources: langResources
});

/**
 * withTranslation higher order component
 * @param {*} Component 
 */
const withTranslation = Component => {

    // Internal component to handle the provider
    function Comp(props) {

        return (
            <I18nextProvider i18n={i18next}>
                <Suspense fallback="loading">
                    <Component {...props} />
                </Suspense>
            </I18nextProvider>
        );
    }

    return Comp;
};

export default withTranslation;